import { useId } from "react";
import { sparklinePath } from "@/lib/chart-math";

interface SparklineProps {
  values: number[];
  color?: string;
  height?: number;
  width?: number;
}

export function Sparkline({
  values,
  color = "var(--primary)",
  height = 34,
  width = 120,
}: SparklineProps) {
  const id = useId();
  const { line, area } = sparklinePath(values, { width, height });

  if (line === "") {
    return (
      <svg
        viewBox={`0 0 ${width} ${height}`}
        preserveAspectRatio="none"
        width="100%"
        height={height}
      />
    );
  }

  const gradientId = `spark-${id.replace(/[^a-z0-9]/gi, "")}`;

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      width="100%"
      height={height}
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor={color} stopOpacity="0.22" />
          <stop offset="1" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      {area && <path d={area} fill={`url(#${gradientId})`} />}
      <path d={line} stroke={color} strokeWidth="1.6" fill="none" />
    </svg>
  );
}
